import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').component('applicationDetails2', {
        template: require('./application-details.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        '$timeout',
        'logger',
        'Upload'
    ];

    function Ctrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        $timeout,
        logger,
        Upload
    ) {
        var vm = this;
        vm.user = SessionService.getUser();

        vm.logout = () => {
            SessionService.clearUser();
            location.reload();
        }

        vm.steps = [
            'Read a passage',
            'Answer some questions',
            'Provide your basic info',
            'Fill in your schedule',
            'Introduce yourself',
        ];

        vm.data = { specs: 1 };

        vm.step_requirements = [
            ['application_audio'],
            ['audio_answer1', 'audio_answer2', 'audio_answer3'],
            ['name', 'phone', 'email', 'kakao_id', 'e_esp', 'e_isp', 'e_street', 'e_city', 'e_zipcode', 'years_of_experience'], //expertise
            ['availability'],
            ['profile_card', 'audio_introduction', 'about_me'],
        ];

        // vm.steps.push('Video');
        // vm.step_requirements.push(['video']);
        vm.steps.push('Do a technical check (optional)');
        vm.step_requirements.push(['specs']);

        vm.check_requirement = (i) => {
            if(!vm.data){
                return false;
            }

            const requirements = vm.step_requirements[i];
            let pass = true;
            requirements.forEach(r => {
                if(!vm.data[r]){
                    pass = false;
                }

                if(r === 'profile_card' && vm.data[r]){
                    const pics = vm.data[r].split('###');
                    
                    if(pics.filter(s => s != '').length < 3){
                        pass = false;
                    }

                }

            });
            
            return pass;

        }

        if(!vm.user){
            $state.go('login2');
        }else{
            getData();
        }

        function getData(){
            
            var req = {
                method: 'GET',
                route: { teacher: 'me' }, 
            };

            QueryService.query(req)
                .then(function(response) {
                    var data = response.data.data;
                    vm.data = data;

                    if(vm.data.profile_card){
                        vm.data.profile_card.split('###').forEach((v,i) => {
                            vm.data['profile_' + (i+1)] = v;
                        });
                    }
                });
        }

        vm.open_modal = (i) => {
            
            if(i == vm.steps.length - 1){
                window.location = '/#!/download_app';
                return;
            }

            var modal = {
                page: i,
                ignoreKeyboard: true,
                title: vm.steps[i],
                data: vm.data
            };

            ModalService.form_modal('', modal, 'applicationDetailModal')
                .then(
                    function(response) { 
                        getData();
                    }, function(error) {
                        getData();
                    }
                );


        }
        // vm.open_modal(4);

        vm.check_requirements = () =>{
            let satisfied = 0;

            vm.step_requirements.forEach((v,i,a) => {
                if(vm.check_requirement(i) || i == vm.step_requirements.length - 1){
                    satisfied++;
                }
            });

            return satisfied === vm.step_requirements.length;

        }

        vm.finalize = () => {
            
            var req = {
                method: 'PUT',
                route: { teacher: vm.user.id }, 
                body: { application_status: 'AUDIO-SCREENING' }
            };

            QueryService.query(req)
                .then(function(response) {
                    getData();
                });
        }
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/application-details-2/application-details.component.js